import React, { useEffect, useState } from 'react';
import { Card, Button, Table, Form, Modal, Badge } from 'react-bootstrap';
import { getClients, addClient } from '../../service/apiService';
import { useNavigate } from 'react-router-dom';

function ClientManagement({ user }) {
  const navigate = useNavigate();

  const [clients, setClients] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [formData, setFormData] = useState({
    client_name: '',
    contact_person: '',
    email: '',
    phone: '',
    client_type: 'software_project',
    address: '',
    city: '',
    notes: '',
  });

  useEffect(() => {
    if (user?.id) loadClients();
  }, [user]);

  const loadClients = async () => {
    const data = await getClients(user.id);
    setClients(data);
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleAddClient = async (e) => {
    e.preventDefault();
    const res = await addClient({ admin_id: user.id, ...formData });
    if (res.status === 'success') {
      alert('Client added successfully');
      setShowAdd(false);
      loadClients();
    } else {
      alert('Failed to add client');
    }
  };

  return (
    <div className="client-management">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Client Management</h3>
        <Button onClick={() => setShowAdd(true)}>+ Add Client</Button>
      </div>

      <Card className="shadow-sm p-3">
        {clients.length === 0 ? (
          <p className="text-muted text-center">No clients found.</p>
        ) : (
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Contact</th>
                <th>Email</th>
                <th>City</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {clients.map((c) => (
                <tr key={c.id} onClick={() => navigate(`/dashboard/clients/${c.id}`)} style={{cursor:'pointer'}}>
                  <td>{c.client_name}</td>
                  <td>
                    <Badge bg="info">{c.client_type.replace('_', ' ')}</Badge>
                  </td>
                  <td>{c.phone}</td>
                  <td>{c.email}</td>
                  <td>{c.city}</td>
                  <td>{new Date(c.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card>

      {/* Add Client Modal */}
      <Modal show={showAdd} onHide={() => setShowAdd(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Client</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleAddClient}>
            <Form.Group className="mb-3">
              <Form.Label>Client Name</Form.Label>
              <Form.Control
                name="client_name"
                value={formData.client_name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Client Type</Form.Label>
              <Form.Select
                name="client_type"
                value={formData.client_type}
                onChange={handleChange}
              >
                <option value="software_project">Software Project</option>
                <option value="college_tieup">College Tie-up</option>
                <option value="business_tieup">Business Tie-up</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Contact Person</Form.Label>
              <Form.Control
                name="contact_person"
                value={formData.contact_person}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <Form.Control
                name="city"
                value={formData.city}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                name="notes"
                rows={2}
                value={formData.notes}
                onChange={handleChange}
              />
            </Form.Group>

            <Button variant="primary" type="submit">
              Save Client
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ClientManagement;
